import { render, staticRenderFns } from "./tableBody.vue?vue&type=template&id=6bad6883&scoped=true"
import script from "./tableBody.vue?vue&type=script&lang=js"
export * from "./tableBody.vue?vue&type=script&lang=js"
import style0 from "./tableBody.vue?vue&type=style&index=0&id=6bad6883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad6883",
  null
  
)

export default component.exports